<template>
  <div>
    <!-- <v-img :src="ImageUrl || ''" max-height="300" /> -->
    <input type="file" ref="file" @change="onFileChange" style="display:none" />

    <span
      class="file-upload__image__placeholder hover-pointer"
      :class="{ 'file-upload__image__placeholder--active': ImageUrl }"
      @click="showImagePreview"
      >{{ imageName ? imageName : $t("label.upload_image") }}</span
    >
    <v-btn
      class="button button--upload"
      small
      text
      @click="$refs.file.click()"
      v-on="$attrs"
      :title="$t('label.upload_image')"
    >
      <v-icon dark> mdi-cloud-upload</v-icon>
      <!-- <span>{{ $t("label.hoss") }}</span> -->
    </v-btn>

    <!-- Image Preview -->
    <global-image-preview
      :showDialog="overlay"
      :imagePath="ImageUrl"
      @closePreview="overlay = false"
    />
    <!-- Image Preview -->

    <v-dialog v-model="errorDialog" max-width="300" persistent>
      <v-card>
        <v-card-text class="subheading">{{ ImageErrorMsg }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="resetData">{{ $t("button.got_it") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { isValidImgType, isValidImgSize } from "@/utils/validate";
import { UpdateMedia } from "@/helpers/apiMethods";

export default {
  props: {
    maxSize: {
      type: Number,
      default: 1
    },
    imgUrl: {
      type: String,
      default: null
    },
    imgId: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    maxHeight: {
      type: Number,
      default: 200
    },
    minHeight: {
      type: Number,
      default: 200
    },
    reset: {
      type: Boolean,
      default: false
    },
    resetToggle: {
      type: Boolean,
      default: false
    },
    fieldName: {
      type: String,
      default: ""
    },
    value: {
      type: String
    }
  },
  watch: {
    reset: {
      handler(newValue) {
        if (newValue === true) {
          this.resetImageFile();
        }
      }
    },
    resetToggle: {
      handler() {
        this.resetImageFile();
      }
    },
    imgUrl: {
      handler(newValue) {
        if (newValue) {
          this.imageName = this.$t("label.show_image");
          this.ImageUrl = newValue;
        }
      },
      immediate: true
    }
  },
  computed: {
    ImageErrorMsg() {
      if (this.errorType === "MIME") {
        return this.$t("validation.imageType");
      } else if (this.errorType === "SIZE") {
        return this.$t("validation.imageSize", { count: this.maxSize });
      } else if (this.errorType === "DIMENSIONS") {
        return this.$t("validation.imageDimensions", {
          width: this.width,
          height: this.height
        });
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      imageName: null,
      ImageUrl: null,
      errorDialog: null,
      errorText: "",
      errorType: "",
      //   imagePreview: "",
      absolute: false,
      overlay: false,
      zIndex: 990
    };
  },
  methods: {
    onFileChange(e) {
      if (e.target.files.length > 0) {
        let imageFile = e.target.files[0];
        // with Dimensions
        if (this.width && this.height) {
          if (this.validateType(imageFile)) {
            this.validateDimentions(imageFile)
              .then(() => {
                this.readImage(imageFile);
              })
              .catch(() => {
                this.errorType = "DIMENSIONS";
                this.errorDialog = true;
              });
          }
          // without Dimensions
        } else {
          if (this.validateType(imageFile)) {
            this.readImage(imageFile);
          }
        }
      }
    },
    readImage(imageFile) {
      if (this.validateSize(imageFile)) {
        // console.log("image file", imageFile);
        this.imageName = imageFile.name;
        this.ImageUrl = URL.createObjectURL(imageFile);
        if (imageFile) {
          let dataObj = {
            file: imageFile
          };
          if (this.fieldName) {
            dataObj.name = this.fieldName;
            this.$emit("fileSelected", dataObj);
          } else {
            this.$emit("fileSelected", dataObj);
          }

          if (this.imgId) {
            this.autoUpdate(dataObj.file);
          }
        }
      }
    },
    autoUpdate(image) {
      let formData = new FormData();
      formData.append("file", image);
      formData.append("_method", "PUT");
      formData.append("locale", "en");

      UpdateMedia({ id: this.imgId, data: formData })
        .then(res => {
          const { media } = res.data;
          this.$emit("ImageUpdated", media);
        })
        .catch(err => {
          console.log(err);
        });
    },
    validateDimentions(file) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.addEventListener(
          "load",
          () => {
            let width = image.naturalWidth;
            let height = image.naturalHeight;
            if (width !== this.width && height !== this.height) {
              reject(false);
            } else {
              resolve(true);
            }
          },
          false
        );
      });
    },
    validateSize(file) {
      if (isValidImgSize(file.size, this.maxSize)) {
        return true;
      } else {
        this.errorType = "SIZE";
        this.errorDialog = true;
        return false;
      }
    },
    validateType(file) {
      if (isValidImgType(file)) {
        return true;
      } else {
        this.errorType = "MIME";
        this.errorDialog = true;
        return false;
      }
    },
    resetImageFile() {
      this.imageName = this.$t("label.upload_image");
      this.ImageUrl = null;
      this.$refs.file.value = "";
    },
    resetData() {
      this.$refs.file.value = "";
      this.errorDialog = false;
      setTimeout(() => {
        this.errorType = "";
      }, 300);
    },
    showImagePreview() {
      if (this.ImageUrl) {
        this.overlay = true;
      }
    }
  }
};
</script>

<style></style>
